export default function initAudioMod() {
	const init = () => {
		initMefaAudio();
	}

	const initMefaAudio = () => {
		const mefaAudio = document.querySelectorAll('.mefa-audio');

		mefaAudio.forEach(audio => {
			const timestamps = audio.querySelectorAll('.timestamp');
			timestamps.forEach(timestamp => {
				timestamp.addEventListener('click', (event) => {
					console.log(timestamp.getAttribute('data-target'));
					const target = document.getElementById(timestamp.getAttribute('data-target'));
					if(target){
						target.currentTime = timestamp.getAttribute('data-time');
						target.play();
					}
				});
			});
		});
	}



	init();
}

